<template>
  <el-dialog
    class="sdk-terms"
    title=""
    :visible.sync="visible"
    width="900px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <h1>GENERAL TERMS AND CONDITIONS FOR DEVELOPER</h1>
    <el-scrollbar style="height: 450px;">
      <p>
        THIS GENERAL TERMS AND CONDITIONS FOR DEVELOPER (“Terms and Conditions”) is entered into by
        and between Youmi Technology (HK) Limited(“Advertiser”) and Developer(“YOU”).
      </p>
      <p>
        By using and accessing the website of services, Developer acknowledges that it has read,
        understands and agrees to be bound by this Terms and Conditions.
      </p>
      <h2>General</h2>
      <p>
        This Terms and Conditions shall govern the relationship between Advertiser and Developer for
        using Developer’s network/system/platform/resources for advertising purposes. All Developer
        accepted by Developer are subject to the Terms and Conditions. The Developer and the Terms
        and Conditions contain all of the terms that Advertiser and Developer have agreed upon. The
        accompanying Developer and this Terms and Conditions (collectively, this "Agreement")
        comprise the entire agreement between Advertiser and Developer, and supersede all prior or
        contemporaneous understandings, agreements, negotiations, representations and warranties,
        and communications, both written and oral. In the event that any terms outlined on the
        Developer conflict with those under the Terms and Conditions, the terms upon the Developer
        shall prevail.
      </p>
      <p>
        The Terms and Conditions prevail over any of Developer’s general terms and conditions
        regardless whether or when Developer has submitted its request for proposal, order, or such
        terms. This Terms and Conditions to Developer does not constitute acceptance of any of
        Developer's terms and conditions and does not serve to modify or amend this Terms and
        Conditions.
      </p>
      <h2>ARTICLE 1: SCOPE OF COLLABORATION</h2>
      <p>
        1.1 Developer shall conduct an advertising campaign for Advertiser’s client, to promote the
        mobile application or other advertising materials (collectively “Materials”) provided by
        Advertiser.
      </p>
      <h2>ARTICLE 2: PAYMENT</h2>
      <p>
        2.1 In consideration for Developer to providing the services as contemplated by this
        Agreement, Advertiser will pay a payment in United States Dollars (“USD”) as stipulated in
        Insert Order on the following basis:
      </p>
      <p>
        a) All numbers in respect of the advertising campaign for the purposes of payment to
        Developer hereunder shall be based exclusively on the Advertiser's reporting system, which
        shall be conclusive.
      </p>
      <p>
        b) Developer shall issue an invoice to Advertiser after confirmation of the payment and
        Advertiser shall pay the payment within thirty (30) days from the Advertiser's receipt of
        such invoice. If Advertiser does not receive payment from Advertiser’s client for any reason
        whatsoever, Advertiser shall have no liability to pay to the Developer.
      </p>
      <p>
        c) In event that double-week payment, weekly payment or monthly payment is mutually agreed
        by both parties in INSERTION ORDER, Developers shall be informed that, Advertiser is
        entitled to deduct or refund the payment resulting from fraud or unqualified traffic and
        shall provide proofs to Developer, Developers shall agree to bear the deduction or refund in
        the following payment.
      </p>
      <p>
        d) Notwithstanding anything else to the contrary set forth in the Agreement, Developer
        acknowledges and agrees that Advertiser shall have no obligation to pay Developer any
        payment with respect to amounts generated as a result of: (i) Developer’s breach of any of
        the terms and conditions of the Agreement; and/or (ii) Developer’s breach of any Applicable
        Rules; and/or (iii) traffic that exceed any cap and/or budget agreed between the parties in
        writing; and/or (iv) fraud or unqualified traffic.
      </p>
      <p>
        2.2 Developer’s bank account is subject to the information provided on this website.
        Developer shall inform Advertiser of any changes in its bank account information via email.
        If Developer authorize third party to receive the payment, it shall issue a Letter of
        Authorization to Advertiser. All liabilities and disputes arising from Party B's designated
        third party to receive the payment, shall be borne by Party B.
      </p>
      <h2>ARTICLE 3: OBLIGATIONS</h2>
      <p>
        3.1 Developer shall make every effort to uphold the highest ethical and commercial
        standards, and comply with all applicable laws, Advertiser and Advertiser’s client
        restrictions (which will be send to Developer from time to time ) to promote the Materials.
      </p>
      <p>
        3.2 Developer shall warrants that the traffic it provides is true and valid. In case of
        fraudulent or unqualified traffic (as determined solely by Advertiser), Advertiser may
        deduct or withhold payments from Developer, block Developer's traffic immediately. If any
        fraudulent or unqualified traffic has paid to Developer, Developer shall refund it to
        Advertiser or Advertiser shall be entitled to setting off such amounts from any future
        Developer’ payment. If the Advertiser unilaterally considers the circumstances
        serious,Developer will forfeit its entire payment that has been detected as fraudulent for
        all programs and its account will be terminated.
      </p>
      <p>
        3.3 Developer shall not place the Materials on any placement that harms the good will or
        reputation of the Advertiser and Advertiser’s client or that disparages or brings Advertiser
        and Advertiser’s client into disrepute, including, but not limited to placement that contain
        indecent, illegal, misleading, harmful, abusive, harassing, liable, defamatory or other
        offensive contents including inappropriate pornographic, sexual, racism, obscene,
        excessively profane, racist, ethnically offensive, threatening, infringing, excessively
        violent, libelous, gambling-related, or discriminatory activity etc. websites/content
        networks.
      </p>
      <p>
        3.4 Developer warrants not to involve, advertise or distribute Advertiser and Advertiser’s
        client’s files, banners, text links, software or any kind of related the Materials with
        incentive traffic, p2p, adware, spywares, malware or any other kind software/online scripts.
        If Advertiser requests that its Materials be removed from or not placed in any such context,
        Developer will comply with such request promptly.
      </p>
      <p>
        3.5 Each party confirms that it has complied, and will continue to comply with its
        obligations relating to Personal Data that apply to it under applicable Data Protection
        Laws.
      </p>
      <p>
        3.6 Developer warrants that it has provided adequate notices to and obtained valid consents
        from Data Subjects (or his partners warranted him that they had done it), in each case, to
        the extent necessary for Advertiser to Process their Personal Data or other information in
        connection with the Agreement, including, without limitation for direct marketing activities
        and international transfers of Personal Data outside of the EEA. Developer will on request
        provide records of all relevant consents obtained (or make his partners who warranted to
        provide) to Advertiser. Developer will not by act or omission, cause Developer to violate
        the Developer’s Privacy Policy, any Data Protection Laws, notices provided to, or consents
        obtained from, Data Subjects as result of Processing Personal Data in connection with or
        Advertiser otherwise performing the Service under the Agreement.
      </p>
      <p>
        3.7 Advertiser will Process Personal Data in accordance with the Advertiser ‘s Privacy
        Policy that shall be in compliance with Data Protection Laws of which Developer provide
        warranty herein.
      </p>
      <h2>ARTICLE 4: INTELLECTUAL PROPERTY RIGHTS</h2>
      <p>
        4.1 Advertiser or Advertiser’s client has exclusive right, title and interest to the
        Materials and any other files or document provided to Developer, and Developer has no rights
        therein save the limited right to providing service pursuant to the articles hereof.
        Developer shall not use any Materials for other purposes without Advertiser's prior written
        consent.
      </p>
      <p>
        4.2 Advertiser has all the intellectual property rights of the programs provided by
        Advertiser, advertising ideas and products created by Advertiser.
      </p>
      <h2>ARTICLE 5: CONFIDENTIALITY</h2>
      <p>
        5.1 Confidential Information may include any information, including but not limited to,
        technical and business information, business plans, financial reports, financial data,
        employee data, software or firmware code, product designs and/or specifications, algorithms,
        computer programs, mask works, inventions, unpublished patent applications, manufacturing or
        other technical or scientific know-how, specifications, technical drawings, diagrams,
        schematics, technology, processes, and any other trade secrets, discoveries, ideas,
        concepts, know-how, techniques, materials, formulae, compositions, information, data,
        results, plans, surveys and/or reports of a technical nature or concerning research and
        development and/or engineering activity, proprietary ideas, patentable ideas, copyrights
        and/or trade secrets, existing and/or contemplated products and services or software whether
        marked as “Confidential” at the time of its disclosure or not, and provided by one party
        (“Discloser”) to another party (“Recipient”) in the course of ordinary business. Youmi and
        Developer agree that the information provided in this Agreement shall be considered as
        Confidential Information. Recipient shall not disclose the Confidential Information to any
        third party without the Discloser´s written consent. Each Party will promptly return or
        destroy the other Party’s Confidential Information upon written request.
      </p>
      <p>
        5.2 Confidential Information does not include information that: (i) is generally available
        in the public domain at the time of its disclosure; or (ii) was developed by employees or
        agents of the Recipient independently of, and without reference to, the Confidential
        Information; or (iii) is rightfully received by the Recipient from a third party not owing a
        duty of confidentiality to the Discloser (in which case and if requested by the Discloser,
        the Recipient will inform the Discloser about the identity of the third party and the exact
        information received). In the event that one Party is requested or required (whether by law
        or regulation) to disclose any Confidential Information or a portion thereof, that Party
        agrees to give the other non-disclosing Party prompt written notice of such request or
        requirement so that the non-disclosing Party may seek an appropriate order or other remedy
        protecting the Confidential Information from disclosure and cooperate with the
        non-disclosing Party, at the non-disclosing Party’s expense, to obtain such protective order
        or other remedy. In the case that a protective order or remedy is not obtained or if the
        non-disclosing Party waives its right to seek such an order or other remedy, then the
        disclosing Party may furnish only that portion of the Confidential Information which it is
        legally required to disclose and it shall give the non-disclosing Party written notice of
        the Confidential Information to be disclosed as far in advance of disclosure as practicable
        and use commercially reasonable efforts to obtain assurances that confidential treatment
        shall be accorded to such Confidential Information.
      </p>
      <p>
        5.3 Developer undertakes not to disclose to any third party the programs provided by
        Advertiser, operation data, advertising ideas, products created by Advertiser and the
        contents of this Agreement through this cooperation. If Developer breaches this clause, it
        shall compensate all the losses caused to Advertiser, and bear corresponding legal
        responsibilities.
      </p>
      <h2>ARTICLE 6: INDEMNIFICATION</h2>
      <p>
        6.1 Each Party will defend, indemnify and hold harmless to the other Party and its
        directors, officers, employees, agents, stockholders and Affiliates from any and all
        damages, liabilities, costs and expenses (including reasonable attorneys’ fees)
        (collectively, “Losses”) resulting from any claim, action, suit, demand, judgment or
        proceeding (a “Claim”), whether or not involving a third party claim which arise out of,
        relate to or result from either Party’s breach of its obligations under this Agreement or
        any applicable law.
      </p>
      <h2>ARTICLE 7: TERM AND TERMINATION</h2>
      <p>
        7.1 The term of this Agreement commences on the Effective Date and and continues for a
        period of one (1) year, unless it is earlier terminated as provided under this Agreement.
      </p>
      <p>
        7.2 If this Agreement expires, the term will automatically extend for a further period of
        one (1) year unless one Party raise an objection in writing within ten (10) business days
        before the expiration. The automatically extension of this Agreement could be applied
        continuously.
      </p>
      <p>
        7.3 Advertiser shall have the right to terminate the advertising campaign with Twenty-four
        (24) hours prior written notice.
      </p>
      <p>
        7.4 In any case, the Advertiser can exercise its right of withdrawal, modification or
        suspension of the advertising campaign in accordance with a notice period of Twenty-four
        (24) hours (Except for special circumstances).
      </p>
      <h2>ARTICLE 8: FORCE MAJEURE</h2>
      <p>
        8.1 Neither party will be liable for a delay or default in the performance of its respective
        obligations under this Agreement if such delay or default is caused by conditions beyond its
        reasonable control, including but not limited to, fire, flood, accident, earthquakes,
        telecommunications line failures, electrical outages, network failures, acts of God or
        labour disputes (“Force Majeure Event”). If a Force Majeure Event continues for a period of
        five (5) Business days, either party has the right to cancel the relevant Insertion Order
        without breach of this Agreement.
      </p>
      <h2>ARTICLE 9: FORBIDDENS</h2>
      <p>
        9.1 During the term of this Agreement, Developer will not seek, in any way, directly or
        indirectly to approach any of Advertiser’s staff and/or relatives, friends or any other
        third party into any specific bribery(including but not limited to gifts of cash, goods, or
        in any other shape of advantage or benefits, etc. ).Advertiser has the right to terminate
        this Agreement and withhold the payment if Developer breach this article.
      </p>
      <p>
        9.2 During the term of this Agreement and for a period of one (1) year thereafter,
        Advertiser will not solicit or entice or attempt to solicit or entice any of the employees
        of Developer to enter into employment service with Advertiser or a competitor of Developer.
      </p>
      <h2>ARTICLE 10: SETTLEMENT OF DISPUTES AND GOVERNING LAWS</h2>
      <p>
        10.1 The execution, validity, interpretation and performance of this Agreement shall be
        governed by and construed in accordance with the Laws of the People’s Republic of China.
      </p>
      <p>
        10.2 Advertiser and Developer agree that any disputes arising out of or in connection with
        the Insertion Order or this Agreement, shall be submitted to the Guangzhou Arbitration
        Commission for arbitration which shall be conducted in accordance with its arbitral rules of
        procedure. The award shall be final and binding on Advertiser and Developer.
      </p>
      <p>
        The Parties agree that they may exchange signed copies of Agreement by electronic (including
        email or facsimile) transmission. Each party agrees that such electronic transmission shall
        have the same force and effect as delivery of original signatures and that each party may
        use such electronically-transmitted copies as evidence of the execution and delivery of the
        Agreement by all parties to the same extent that an original signature could be used. By
        signing below each party agrees to be bound by the terms of this Agreement.
      </p>
    </el-scrollbar>
    <div class="footer" slot="footer">
      <div class="agreement-check">
        <el-form :model="agreement" :rules="checkRules" ref="checkedForm">
          <el-form-item prop="checked">
            <el-checkbox-group v-model="agreement.checked">
              <el-checkbox label="I have read and agree to the above agreement"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <el-button type="button" @click="close()">
        I Agree
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: this.show,
      agreement: {
        checked: false,
      },
      checkRules: {
        checked: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('You must accept the general terms and conditions'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    show(newValue) {
      this.visible = this.show
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    aff_id: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    close() {
      const aff_id = this.aff_id
      this.$refs.checkedForm.validateField('checked', error => {
        if (!error) {
          this.$http.get(`/api/aff/sdk_agreement/${aff_id}/`).then(res => {
            this.visible = false
          })
        } else {
          return undefined
        }
      })
    },
  },
}
</script>

<style lang="scss">
.sdk-terms {
  h1 {
    font-size: 20px;
    text-align: center;
    color: #0080cc;
  }
  h2 {
    font-size: 18px;
    color: #303133;
  }
  p {
    margin: 8px 0;
    color: #303133;
    font-size: 14px;
    line-height: 22px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-scrollbar {
    .el-scrollbar__wrap {
      background: #f2f2f2;
      overflow-x: hidden;
      padding: 24px 32px 0 32px;
      .el-scrollbar__view {
        margin-bottom: 40px;
      }
    }
  }
  .agreement-check {
    text-align: left;
  }
}
</style>
